import { Component, OnInit } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { FooterComponent } from '../footer/footer.component';
import { ActivatedRoute, Router } from '@angular/router';
import { ApiService } from 'src/app/services/api.service';
import { Title } from '@angular/platform-browser';

@Component({
  selector: 'app-transfer-expired',
  templateUrl: './transfer-expired.component.html',
  styleUrls: ['./transfer-expired.component.css'],
  standalone: true,
  imports: [TranslateModule, FooterComponent]
})
export class TransferExpiredComponent implements OnInit {

  key: any = '';
  auth: any = '';
  currentUrlLocation: any = '';
  currentUrl: string = '';
  currentUser: any = '';
  LogoUrl: any = '';
  companyName: any = '';
  companyOwnWebsite: any = '';
  borderTopColor: any = '';
  borderBottomColor: any = '';
  buttonBGselectedColor: any = '';
  buttonTextselectedColor: any = '';

  constructor(private activatedRoute: ActivatedRoute,
      private router: Router,
      private titleService: Title,
      private apiService: ApiService) { }

  ngOnInit(): void {

   this.getFreelancerBrandDetails();

  }


  getFreelancerBrandDetails() {
    // Use window.location instead of deprecated router API
    this.currentUrl = window.location.origin;

    this.currentUrlLocation = window.location.href;
    console.log('currentURL:', this.currentUrl);
    var pathArray = this.currentUrl.split('.');
    var host = pathArray[0].split('//');
    //MARK: Important place to debug easily.
    //var url = host[1];
    var url = window.location.host;
     console.log('currentDomain:', url);
    let jSon = {
      brand_url: url,
      // brand_url: 'oyesamrat.net0.download'
    }

    // console.log('jSonBody',jSon);

    this.apiService.getBrandDetails(jSon).subscribe((res: any) => {

      console.log('brandData',res);

      if (res.success == 0) {
        this.router.navigate(['/page-not-found'])
        this.titleService.setTitle('Transfer Center Download');
      }
      else if (res.success == 1) {
        this.currentUser = res.data;
        this.LogoUrl = this.currentUser.logo_url;
        this.companyName = this.currentUser.company_name;
        // Determine website URL based on user type and hyperlink value
        let websiteUrl: string;

        if (this.currentUser.company_website_hyperlink == null || this.currentUser.company_website_hyperlink == '') {
          // No custom URL provided - use default based on user type
          if (this.currentUser.is_master_user == 1 || this.currentUser.is_master_user == '1') {
            websiteUrl = "https://transfercenter.jp/business.html";
          } else {
            websiteUrl = "https://transfercenter.jp";
          }
        } else {
          // Custom URL provided - use it
          websiteUrl = this.currentUser.company_website_hyperlink;
        }

        // Ensure URL has proper protocol (http:// or https://)
        this.companyOwnWebsite = this.ensureUrlHasProtocol(websiteUrl);
        console.log('Current User ', JSON.stringify(this.currentUser));
        console.log('Is Master User:', this.currentUser.is_master_user);
        console.log('Company Website URL:', this.companyOwnWebsite);
        console.log('Current User ', JSON.stringify(this.currentUser));
        // console.log('organization name', this.currentUser.organization_name);
        if (this.currentUser.organization_name != '' || this.currentUser.organization_name != 'null' || this.currentUser.organization_name != null) {
          this.titleService.setTitle(this.currentUser.organization_name);
        }
        else {
          this.titleService.setTitle('Transfer Center Download');
        }

        if (this.currentUser.button_background_color != null && this.currentUser.button_background_color != 'null' && this.currentUser.button_background_color != '') {
          // this.buttonBGselectedColor = this.currentUser.button_background_color;
          this.borderTopColor = '1px solid ' + this.currentUser.button_background_color;
          this.borderBottomColor = '1px solid ' + this.currentUser.button_background_color;
        }
        else {
          // this.buttonBGselectedColor = '#2196f3';
          this.borderTopColor = '1px solid ' + this.buttonBGselectedColor;
          this.borderBottomColor = '1px solid ' + this.buttonBGselectedColor;
        }
      }

    }, err => {
      // console.log(err);
    })
  }

  ensureUrlHasProtocol(url: string): string {
    if (!url) {
      return "https://transfercenter.jp";
    }

    // Check if URL already has a protocol
    if (url.match(/^[a-zA-Z][a-zA-Z\d+\-.]*:/)) {
      return url;
    }

    // Add https:// if no protocol exists
    return 'https://' + url;
  }

}
